import axios from 'axios';

function randomOrderID() {
    return "ord_" + (Date.now().toString(36) + "_" + Math.random().toString(36).substr(-5)).toLowerCase();
}

function build(restaurant, order, transaction) {
    const payload = {
        "restaurant": {
            "id": restaurant.id,
            "name": restaurant.name,
            "phone": restaurant.phone_number,
            "token": restaurant.token,
        },
        "order": {
            "amount": order.amount,
            "commissions": order.commissions,
            "coupon": order.coupon,
            "customer": order.customer,
            "customers": order.customers,
            "id": randomOrderID(),
            "number": order.number,
            "payed": order.payed,
            "products": order.products,
            "quantity": order.quantity,
            "table": order.table,
            "timestamp": order.timestamp,
            "total": order.total,
            "type": order.type,
            "note": order.note,
        },
        "transaction": {
            "id": transaction.id,
            "provider": transaction.provider,
        },
    };

    return payload;
}

async function doPost(data) {
    const PATH = "https://orders.mycontactlessmenu.mycia.it/api/webapp/orders";

    try {
        let response = await axios.post(PATH, { data: data });

    } catch (err) {
        console.error(err);

        const formData = new FormData();
        formData.append("name", "stripe.doPost");
        formData.append("date", new Date());
        formData.append("error", JSON.stringify(err));
        formData.append("data", JSON.stringify({ data: data }));

        const response = await axios.post('https://script.google.com/macros/s/AKfycbwCDszudF2KFAfSjVHLuaiY1zirNhR7rf_R6l49gwq6L9ct4esKSSPIfIggJ2kLySNEOw/exec',
            formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    }
}

const checkoutClient = {
    randomOrderID,
    build,
    doPost,
};
export default checkoutClient;
